const BlogMergeAllLoadMore = {
  init() {
    const button = document.querySelector('[data-merge-all-load-more]');
    if (!button || button.dataset.bound) return;
    button.dataset.bound = 'true';

    this.button = button;
    this.batchSize = parseInt(button.dataset.batchSize, 10) || 6;

    const blogsScript = document.querySelector('[data-merge-all-blogs]');
    this.blogs = blogsScript ? JSON.parse(blogsScript.textContent) : [];

    button.addEventListener('click', () => this.onClick());
  },

  getGrid() {
    return document.querySelector('#ProductGridContainer .main-blog__items');
  },

  hiddenItems(grid) {
    return Array.from(grid.querySelectorAll('.f-column[hidden]'));
  },

  hasMoreBlogs() {
    return this.blogs.some((blogState) => !blogState.exhausted);
  },

  async onClick() {
    if (this.button.classList.contains('btn--loading')) return;

    const grid = this.getGrid();

    if (this.hiddenItems(grid).length < this.batchSize && this.hasMoreBlogs()) {
      this.setLoading(true);
      await this.fetchMore(grid);
      this.setLoading(false);
    }

    this.revealBatch(grid);
  },

  setLoading(isLoading) {
    this.button.classList.toggle('btn--loading', isLoading);
    this.button.classList.toggle('pointer-events-none', isLoading);
  },

  async fetchMore(grid) {
    const sectionId = FoxTheme.utils.getSectionId(this.button);

    const fetches = this.blogs
      .filter((blogState) => !blogState.exhausted)
      .map((blogState) => this.fetchBlogPage(blogState, sectionId));

    const results = await Promise.all(fetches);
    const newItems = results.flat();

    newItems.forEach((item) => this.insertSorted(grid, item));
  },

  async fetchBlogPage(blogState, sectionId) {
    const url = new URL(blogState.url, window.location.origin);
    url.searchParams.set('page', blogState.nextPage);
    url.searchParams.set('section_id', sectionId);

    try {
      const response = await fetch(url.toString());
      const html = await response.text();
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const items = Array.from(parsedHTML.querySelectorAll('#ProductGridContainer .products-list .f-column'));

      if (items.length < this.batchSize) {
        blogState.exhausted = true;
      } else {
        blogState.nextPage += 1;
      }

      return items;
    } catch (error) {
      blogState.exhausted = true;
      return [];
    }
  },

  insertSorted(grid, item) {
    item.hidden = true;
    const itemDate = Number(item.dataset.publishedAt);
    const target = this.hiddenItems(grid).find((el) => Number(el.dataset.publishedAt) < itemDate);

    if (target) {
      grid.insertBefore(item, target);
    } else {
      grid.appendChild(item);
    }
  },

  revealBatch(grid) {
    const hidden = this.hiddenItems(grid).slice(0, this.batchSize);
    hidden.forEach((item) => {
      item.hidden = false;
    });

    if (this.hiddenItems(grid).length === 0 && !this.hasMoreBlogs()) {
      this.button.closest('.main-blog__load-more').remove();
    }

    if (typeof grid.init === 'function') {
      grid.init();
    }
  },
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => BlogMergeAllLoadMore.init());
} else {
  BlogMergeAllLoadMore.init();
}

document.addEventListener('collection:rerendered', () => BlogMergeAllLoadMore.init());
